import { FieldError } from 'react-hook-form'
import styled, { css } from 'styled-components'

interface WrapperProps {
  width?: string
  height?: string
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width || '100%'};
`

export const Label = styled.label`
  margin: 0 0;
  font-size: 1.2rem;
  text-transform: capitalize;
`

interface SelectProps {
  height?: string
  error?: FieldError
}

export const Select = styled.select<SelectProps>`
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  height: ${(props) => props.height || '100%'};
  cursor: pointer;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #2962ff;
  }

  ${({ error }) => error
    && css`
      box-shadow: 0 0 0.2rem 0.09rem red;
    `}
`
export const Option = styled.option`
  width: 100%;
`

export const Error = styled.p`
  margin: 3px 0 6px 0;
  color: #ab003c;
`
